import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../components/dynamicscreens/DynamicForm";
import { OrderApprovalAuthorityJson } from "../../DynamicFormsJson/MastersJSON/orderApprovalAuthority";
import { getActiveSalesTeam, getActiveSalesTeamOfAboveType } from "../../Slice/salesExecutive.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { serverMsg, noInternetMsg } from "../../config/messageconstant";
import { getStockHolderBySalesTeamId } from "../../Slice/StackHolder.slice";
import { compose } from "recompose";
import { withRouter } from "../../components/withRouter";

class OrderApprovalAuthorityForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                salesTeamDetail: this.props.salesTeamList?.salesExecutive,
                stockHolderDetail: [],
            },
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.salesTeamList !== nextProps.salesTeamList) {
            if (this.props.salesTeamList?.salesExecutive !== nextProps.salesTeamList?.salesExecutive) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        salesTeamDetail: nextProps.salesTeamList?.salesExecutive,
                    },
                });
            }
        }

        if (this.props.salesTeamListForAboveType !== nextProps.salesTeamListForAboveType) {
            if (this.props.salesTeamListForAboveType?.reportingAuthority !== nextProps.salesTeamListForAboveType?.reportingAuthority) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        authoritySalesTeamDetail: nextProps.salesTeamListForAboveType?.reportingAuthority,
                    },
                });
            }
        }

    }

    async componentDidMount() {
        const {
            getActiveSalesTeam,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });

            await getActiveSalesTeam({
                orderApprovalAuthorityId: this.props.params.id || "",
                flag: this.props.params.id ? 1 : 0,
            }).then(({ success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });

            showLoador({ loador: false });

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }


    getListById = async (data) => {
        const {
            getActiveSalesTeamOfAboveType,
            showLoador,
            showNotification,
            getStockHolderBySalesTeamId,
        } = this.props;
        if (navigator.onLine) {
            if (data.salesTeamId && data.salesTeamId != "") {
                showLoador({ loador: true });

                await getActiveSalesTeamOfAboveType({ salesTeamId: data.salesTeamId }).then(
                    ({ success }) => {
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );

                await getStockHolderBySalesTeamId({
                    salesTeamId: data.salesTeamId
                }).then(({ response, success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                        this.setState({
                            dynamicMasterData: {
                                ...this.state.dynamicMasterData,
                                stockHolderDetail: response,
                            },
                        });
                    }
                });

                showLoador({ loador: false });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };




    render() {
        const { dynamicMasterData } = this.state;
        const hideStockHolderOnOrderApproval = localStorage.getItem("hideStockHolderOnOrderApproval") !== null ? localStorage.getItem("hideStockHolderOnOrderApproval") : 1;

        return (
            <>
                <DynamicForm
                    formPath={OrderApprovalAuthorityJson.formPath}
                    getListById={this.getListById}
                    screenTitle={OrderApprovalAuthorityJson.screenTitle}
                    fieldMeta={hideStockHolderOnOrderApproval == 1 ?
                        OrderApprovalAuthorityJson.fieldMetaWithoutStockHolder :
                        OrderApprovalAuthorityJson.fieldMeta}
                    apiBaseURL={OrderApprovalAuthorityJson.apiBaseURL}
                    dynamicMasterData={dynamicMasterData}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesTeamList: state.salesExecutive,
    salesTeamListForAboveType: state.salesExecutive,
});
const mapDispatchToProps = {
    getActiveSalesTeam,
    showLoador,
    showNotification,
    getStockHolderBySalesTeamId,
    getActiveSalesTeamOfAboveType,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(OrderApprovalAuthorityForm);